enum MedicalItemTypeEnum {
    EMRTemplate = 0,
    SocialHabitsAndRiskFactors = 1,
    FamilyHistory = 2,
    AlertsAndSpecialNeeds = 3,
    MedicalReaction = 4,
    Attachment = 5,
    Immunization = 6,
    VitalSigns = 7,
    MedicationsAndPrescriptions = 8,
    PastAndOngoingProblemsAndConditions = 11,
    ScreeningTest = 12,
    All = 99
}

export { MedicalItemTypeEnum };
